import { AvatarSizes } from '@capsicum/common';
import { GenericDrawer, Text } from '@capsicum/common-web';
import { ChilizChainCircleWhiteIcon } from '@capsicum/common-web/icons';
import {
	type NCWGovernanceStakingDappOnlyDrawerProps,
	useNCWGovernanceStakingDappOnlyDrawer
} from '@capsicum/features/nc-wallet/shared';
import styled, { useTheme } from 'styled-components';

/**
 * This drawer is displayed when the user click the "Stake" button, informing the user that currently s/he can only
 * connect to Chiliz Governance dApp. This drawer will be discarded when users can connect to other dApps.
 * @param {() => void} closeModal the callback to close the drawer
 * @param {() => void} onContinueButtonActivate the callback to execute when the user click the Continue button
 * @returns JSX this component
 */
export const NCWGovernanceStakingDappOnlyDrawer = ({
	closeModal,
	onContinueButtonActivate
}: NCWGovernanceStakingDappOnlyDrawerProps) => {
	const { colors, spacings } = useTheme();
	const { intlText } = useNCWGovernanceStakingDappOnlyDrawer();

	const handleButtonClick = () => {
		closeModal();
		onContinueButtonActivate();
	};

	return (
		<GenericDrawer
			buttonText={intlText.continueButtonText}
			testID="ncw-governance-staking-dapp-only-drawer"
			onButtonPress={handleButtonClick}
		>
			<S.ChildrenWrapper>
				<ChilizChainCircleWhiteIcon
					color={colors.backgrounds.main.unselected}
					height={AvatarSizes.L}
					width={AvatarSizes.L}
				/>
				<S.TextContainer>
					<S.Title variant="title6">{intlText.title}</S.Title>
					<S.Description variant="text3">{intlText.description1}</S.Description>
					<S.Description style={{ marginTop: parseInt(spacings.small) }} variant="text3">
						{intlText.description2}
					</S.Description>
				</S.TextContainer>
			</S.ChildrenWrapper>
		</GenericDrawer>
	);
};

namespace S {
	export const ChildrenWrapper = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.large};
	`;

	export const TextContainer = styled(ChildrenWrapper)`
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const Title = styled(Text)`
		text-align: center;
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Description = styled(Title)``;
}
